module.exports = __webpack_public_path__ + "static/media/Basisschool.4b7e808b.mp3";